import { ScrollTextIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';

interface EmptySessionsProps {
  variant: 'full' | 'short';
}

export const EmptySessions = ({ variant }: EmptySessionsProps) => {
  const { t } = useTranslation();
  const descriptionKey =
    variant === 'full'
      ? 'brain_logs.empty_state_description'
      : 'brain_logs.empty_state_description_short';

  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <ScrollTextIcon aria-hidden />
        </EmptyMedia>
        <EmptyTitle>{t('brain_logs.empty_state_title')}</EmptyTitle>
        <EmptyDescription>{t(descriptionKey)}</EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
};
